import React from "react";
import NavigateButton from "../../../components/buttonsNavigate";
import {
  FaArrowLeft,
  FaBalanceScale,
  FaCartArrowDown,
  FaCheckCircle,
  FaExclamationTriangle,
  FaHistory,
  FaListUl,
  FaSearch,
  FaCheck,
  FaShoppingCart,
  FaSyncAlt,
} from "react-icons/fa";
import { FaMapMarkerAlt, FaEdit } from "react-icons/fa";
import { FiPackage } from "react-icons/fi";
import { MdRestorePage } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { LiaTruckPickupSolid } from "react-icons/lia";
import { TbTransfer } from "react-icons/tb";
import { FaWarehouse } from "react-icons/fa";

import { LuBoxes, LuPackageCheck } from "react-icons/lu";
import { BsDatabaseFillCheck } from "react-icons/bs";
import {
  FaBoxOpen,
  FaProductHunt,
  FaRegFileLines,
  FaToolbox,
  FaFile,
} from "react-icons/fa6";
import { HiStatusOffline } from "react-icons/hi";

const WareHouse = () => {
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const colors = [
    "bg-[#BF1B26]",
    "bg-[#0D6E99]",
    "bg-[#5E2D79]",
    "bg-[#4CAF50]",
    "bg-[#333333]",
    "bg-[#CCCCCC]",
    "bg-[#FF5733]",
    "bg-[#FFC300]",
    "bg-[#581845]",
    "bg-[#FF851B]",
    "bg-[#7D3C98]",
    "bg-[#01A9DB]",
    "bg-[#7FF050]",
    "bg-[#FF007F]",
    "bg-[#ADD8E6]",
    "bg-[#7EE050]",
  ];
  var host = window.location.host;

  const history = useNavigate();
  return (
    <>
      {/* header */}
      <div className=" mb-5 sticky top-0 flex flex-col bg-white z-50">
        <div className=" w-full bg-dbase h-16">
          <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
            <button onClick={() => history(-1)}>
              <FaArrowLeft />
            </button>
            <h2 className=" text-xl    my-auto">Warehouse</h2>
          </div>
        </div>
      </div>
      <div className=" grid grid-cols-2 container gap-x-6 gap-y-4">
        <>
          {(permissions.pda_warehouse_products || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<FaWarehouse />}
              name={"Product Details"}
              arname={"المنتجات"}
              color={colors[15]}
              onclick={() => history("WarehouseProduct")}
            />
          )}

          {(permissions.pda_warehouse_check_product || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<BsDatabaseFillCheck />}
              name={"Quality Control"}
              arname={"فحص المنتج"}
              color={colors[13]}
              onclick={() => history("checkproduct")}
            />
          )}

          {(permissions.pda_warehouse_bin || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<LuBoxes />}
              name={"Bin"}
              arname={"الصندوق"}
              color={colors[1]}
              onclick={() => history("changeproductaddress")}
            />
          )}

          {(permissions.pda_warehouse_transfer || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<TbTransfer />}
              name={"Quick Warehouse Transfer"}
              arname={"نقل المخزون"}
              color={"bg-[rgb(145,170,0)]"}
              onclick={() => history("QuickWarehousetransfer")}
            />
          )}

          {(permissions.pda_warehouse_change_status || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<FaSyncAlt />}
              name={"Warehouse Transfer"}
              arname={"تغيير الحالة"}
              color={"bg-[rgb(252,186,3)] bg-opacity-90"}
              onclick={() => history("ChangeStatusWarehouse")}
            />
          )}

          {/* {(permissions.pda_warehouse_manage_bin || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
              <NavigateButton
                icon={<FaToolbox />}
                name={"Manage Bin / Reference Quantity"}
                arname={"إدارة الصندوق / كمية المرجع"}
                color={"bg-[rgb(252,0,255)] bg-opacity-90"}
                onclick={() => history("ManageUpcQuantityWarehouse")}
              />
            )} */}

          {(permissions.pda_warehouse_check_address || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<FaSearch />}
              name={"Check Address "}
              arname={"التحقق من العنوان"}
              color={"bg-[rgb(0,50,0)] bg-opacity-90"}
              onclick={() => history("CheckAddressWarehouse")}
            />
          )}

          {/* {(permissions.pda_warehouse_check_reference || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
              <NavigateButton
                icon={<FaSearch />}
                name={"Check Reference "}
                arname={"التحقق من المرجع"}
                color={"bg-[rgb(90,40,3)] bg-opacity-90"}
                onclick={() => history("CheckReferenceWarehouse")}
              />
            )} */}


          {/* {(permissions.pda_warehouse_change_reference || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
              <NavigateButton
                icon={<FaFile />}
                name={"Change Reference"}
                arname={"تغيير المرجع "}
                color={colors[4]}
                onclick={() => history("ChangeReference")}
              />
            )} */}

          {(permissions.pda_warehouse_product_history || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<FaSearch />}
              name={"Product History"}
              arname={"تاريخ المنتج"}
              color={"bg-[rgb(90,40,88)] bg-opacity-90"}
              onclick={() => history("producthistory")}
            />
          )}

          {(permissions.pda_warehouse_seller_stand || host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") && (
            <NavigateButton
              icon={<FaSearch />}
              name={"Seller Stand"}
              arname={" موقف البائع"}
              color={"bg-[rgb(27,60,98)] bg-opacity-90"}
              onclick={() => history("SellerStand")}
            />
          )}


          <NavigateButton
            icon={<FiPackage />}
            name={"Assign To Pallet"}
            arname={"تخصيص إلى منصة التحميل"}
            color={"bg-[rgb(255,149,7)] bg-opacity-90"}
            onclick={() => history("AssignToPallet")}
          />

          <NavigateButton
            icon={<MdRestorePage className=" text-3xl" />}
            name={"Restock Awaiting failed given"}
            arname={"إعادة تخزين"}
            color={"bg-[rgb(98,75,220)] bg-opacity-90"}
            onclick={() => history("RestockWH")}
          />

          {permissions.low_stock_pda &&
            (<NavigateButton
              icon={<FaExclamationTriangle />}
              name={"Low Stock Products"}
              arname={"المنتجات منخفضة المخزون"}
              color={"bg-[rgb(239,68,68)] bg-opacity-90"}
              onclick={() => history("LowStockProducts")}
            />)
          }


        </>
      </div>
    </>
  );
};

export default WareHouse;
